var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from "react";
import { CurrencyInput } from "./CurrencyInput";
export var CurrencyRangeInput = function (props) {
    var _a;
    var _b = __read(React.useState(Number((_a = props.default) !== null && _a !== void 0 ? _a : 0)), 2), internalValue = _b[0], setInternalValue = _b[1];
    React.useEffect(function () {
        if (props.amount !== internalValue) {
            setInternalValue(!isNaN(Number(props.amount)) ? Number(props.amount) : props.amount);
        }
    }, [props.amount]);
    var handleCurrencyInputChange = function (newValue) {
        var numericValue = Number(newValue);
        if (props.min !== undefined && numericValue < Number(props.min)) {
            numericValue = Number(props.min);
        }
        if (props.max !== undefined && numericValue > Number(props.max)) {
            numericValue = Number(props.max);
        }
        setInternalValue(numericValue);
        if (props.onChange) {
            props.onChange(numericValue.toString());
        }
    };
    var handleBlur = function () {
        // Call the onBlur prop when the field loses focus
        if (props.onBlur) {
            props.onBlur(internalValue === null || internalValue === void 0 ? void 0 : internalValue.toString());
        }
    };
    return (React.createElement(React.Fragment, null, props.amount === undefined || props.amount === null ? (React.createElement(React.Fragment, null,
        React.createElement(CurrencyInput, { className: props.clazzName, amount: undefined, onChange: handleCurrencyInputChange, onBlur: handleBlur, isInput: true, placeholder: props.placeholder, disabled: !!props.disabled, withPrefix: props.withPrefix, withoutDecimal: props.withoutDecimal }))) : (React.createElement(CurrencyInput, { className: props.clazzName, amount: internalValue, onChange: handleCurrencyInputChange, onBlur: handleBlur, isInput: true, placeholder: props.placeholder, disabled: !!props.disabled, withPrefix: props.withPrefix, withoutDecimal: props.withoutDecimal }))));
};
